import getLocaleMixins from '../../utils/getLocaleMixins';

const name = 'step-success';

export default {
    name,
    mixins: [getLocaleMixins(name)],
};
